<template>
  <div>
    <el-button
      style="margin-bottom: 10px"
      type="primary"
      @click="openEditPictureDialog(true)"
      >上传新图片</el-button
    >

    <el-table
      :data="pictureListTableData"
      border
      size="small"
      style="width: 500px"
    >
      <el-table-column label="图片" align="center" width="300">
        <template scope="scope">
          <a href="">
            <img
              :src="scope.row.url"
              @click="(event) => onClickPicture(event, scope.row.url)"
              weight="100px"
              height="100px"
            />
          </a>
        </template>
      </el-table-column>
      <el-table-column label="" align="center" width="200">
        <template scope="scope">
          <el-button
            round
            size="small"
            @click="onClickCopyLinkBtn(scope.row.url)"
            >复制链接</el-button
          >
          <el-button
            type="danger"
            round
            size="small"
            @click="onClickDeletePictureBtn(scope.row.url)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>

    <!-- 图片预览弹窗 -->
    <el-dialog :visible.sync="isPreviewDialogVisible">
      <img width="100%" :src="previewDialogImageUrl" alt="" />
    </el-dialog>

    <!-- “编辑图片”对话框 -->
    <EditPictureDialog
      v-if="shouldEditPictureDialogVisible"
      @close="onEditPictureDialogClosed()"
      :value="valueForEditPictureDialog"
    ></EditPictureDialog>
  </div>
</template>

<script>
const axios = require("axios");
const util = require("../../util");

import EditPictureDialog from "./EditPictureDialog";

export default {
  data() {
    return {
      shouldEditPictureDialogVisible: false, // “编辑图片”对话框是否应该显示出来
      valueForEditPictureDialog: null, // 要传递给“编辑图片”对话框的数据
      pictureListTableData: [], // 图片列表里展示的数据
      isPreviewDialogVisible: false, // 是否展示图片预览弹窗
      previewDialogImageUrl: "", // 图片预览弹窗当中展示的图片的url
    };
  },

  created() {
    this.loadPictureList();
  },

  components: {
    EditPictureDialog,
  },

  methods: {
    /**
     * 点击了图片
     * @param {*} event
     * @param {*} pictureUrl
     */
    onClickPicture(event, pictureUrl) {
      event.preventDefault();

      this.previewDialogImageUrl = pictureUrl;
      this.isPreviewDialogVisible = true;
    },

    /**
     * 点击了复制链接按钮
     * @param {*} pictureUrl
     */
    onClickCopyLinkBtn(pictureUrl) {
      navigator.clipboard.writeText(pictureUrl);
      this.$message({
          message: "复制成功",
          type: "success"
      });
    },

    /**
     * 点击了删除图片按钮
     * @param {*} pictureUrl
     */
    onClickDeletePictureBtn(pictureUrl) {
      this.$confirm("确定删除图片？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          await this.deletePicture(pictureUrl);
        })
        .catch(() => {});
    },

    /**
     * 加载图片集合
     */
    async loadPictureList() {
      let resData = (
        await axios.post(
          `${util.getBackendApiBase()}/v1/getPictureList`,
          {},
          {
            headers: {
              token: util.getLoginUserToken(),
            },
          }
        )
      ).data;
      if (resData.code > 0) {
        this.$message({
          message: resData.message,
          type: "error",
        });
        return;
      }

      let listInResp = resData.data.pictureList || [];

      let list = [];
      for (let e of listInResp) {
        list.push({
          url: e.url,
        });
      }

      this.pictureListTableData = list;
    },

    /**
     * 删除一个图片
     */
    async deletePicture(pictureUrl) {
      let resData = (
        await axios.post(
          `${util.getBackendApiBase()}/v1/deletePicture`,
          {
            pictureUrl: pictureUrl,
          },
          {
            headers: {
              token: util.getLoginUserToken(),
            },
          }
        )
      ).data;
      if (resData.code > 0) {
        this.$message({
          message: resData.message,
          type: "error",
        });
        return;
      }

      // 重新加载图片列表
      return this.loadPictureList();
    },

    /**
     * 打开“编辑图片”对话框
     */
    async openEditPictureDialog(isCreate, oldData) {
      this.shouldEditPictureDialogVisible = true;
      this.valueForEditPictureDialog = {
        isCreate: isCreate,
        oldData: oldData,
      };
    },

    /**
     * “编辑图片”对话框关闭了
     */
    async onEditPictureDialogClosed() {
      this.shouldEditPictureDialogVisible = false;

      // 重新拉图片列表
      return this.loadPictureList();
    },
  },
};
</script>